import store from '../store'
import router from '../router'
import { useUserStore } from '@/pinia/user'
import { buriedPointUtil } from './utils'

const apiUrl = import.meta.env.VITE_API_URL
let isRedirect = false
/**
 * 封装的 fetch 请求函数
 * @param {string} url 请求地址
 * @param {object} options 请求配置
 * @param {boolean} options.failedRedirect 请求失败则跳转到错误页，并且携带请求时的 URL
 * @param {boolean} options.manualHandle401Error 手动处理 401 错误，此时自动处理的 401 错误逻辑都将不被触发
 * @returns {Promise} 返回一个 Promise 对象，处理响应或错误
 */
export const fetchData = async (url, options = {}, headers = {}) => {
  const user = useUserStore()

  if (localStorage.getItem('deviceId') === null) {
    localStorage.setItem('deviceId', 'web' + Math.random().toString(36).substr(2))
  }

  const defaultOptions = {
    method: 'GET', // 默认 GET 请求
    headers: {
      'Content-Type': 'application/json',
      tk: user.userInfo.tk || '',
      deviceId: localStorage.getItem('deviceId'),
      userId: user.userInfo.uid,
      ...headers
    },
    ...options
  }

  try {
    const response = await fetch(`${apiUrl}${url}`, defaultOptions)

    // 判断是否请求成功
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    // 假设返回的结果是 JSON 格式
    const data = await response.json()

    // 禁用国家ip
    if (data.code === 302) {
      if (isRedirect === true) return data
      isRedirect = true
      router.replace(data.redirectUrl)
    }

    // 免登录url列表
    const noLoginUrlList = ['/queryMyInfo', '/cart/cartCount']
    const needLogin = noLoginUrlList.findIndex(item => url.includes(item)) === -1

    if (data.code === 500) {
      buriedPointUtil({ eventId: 'AERROR', request: { code: data.code, url, body: defaultOptions.body } })
    }

    if (data.code === 401 && needLogin && !defaultOptions.manualHandle401Error) {
      if (window.location.pathname.includes('/offer')) { // 详情页
        if (url.includes('/cart/cartList')) return // 详情页购物车列表不跳登录
      }

      buriedPointUtil({ eventId: 'AERROR', request: { code: data.code, url, body: defaultOptions.body } })

      router.push({ name: 'guide' })

      user.clearUserInfo()

      return data
    }

    if (defaultOptions.failedRedirect && data.code !== 200) {
      router.push({
        name: 'networkError',
        query: {
          redirect: router.currentRoute.value.fullPath
        }
      })
    }

    /**
     * TODO: 将 empty obj 全局对象操作移除，出现 500 错误，若需要展示则跳转到 Error 页
     */
    if (data.code === 500 && !url.includes('/cart/cartCount') && !url.includes('/b2b/user/register')) {
      if (url.includes('/appb/b2b/product/recommend/productListV2') && window.location.pathname === '/') {
        store.commit('setLoading', false)
        return data
      }
      store.commit('setEmptyObj', {
        msg: data.msg,
        showEmpty: true
      })
      store.commit('setLoading', false)
    }
    if (data.code === 5209) {
      store.commit('setEmptyObj', {
        msg: data.msg,
        showEmpty: true,
        code: 5209
      })
      store.commit('setLoading', false)
    }

    return data
  } catch (error) {
    // 错误处理
    store.commit('setLoading', false)
    console.error('Fetch Error:', error)

    if (defaultOptions.failedRedirect) {
      router.push({
        name: 'networkError',
        query: {
          redirect: router.currentRoute.value.fullPath
        }
      })
    }
    throw error
  }
}

export class ResponseError extends Error {
  constructor (code, message, data) {
    super(message)
    this.code = code
    this.data = data
  }
}
